(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3Referral', {
            templateUrl: 'app/home/referral/referral.component.html',
            controller: ReferralComponent
        });

    ReferralComponent.$inject = ['$scope', '$locale', 'user', 'cultureName'];
    function ReferralComponent($scope, $locale, user, cultureName) {
        var ctrl = this;  
        ctrl.user = user;
        ctrl.referralUrl = 'https://ecomm.golfcanada.ca/home?ref=' + user.golfCanadaCardId;  
        
        $scope.copyToClipboard = function() {
            var path = ctrl.referralUrl;         
            navigator.clipboard.writeText(path).then(console.log('copied!'));          
        } 
   }
})();